<template>
  <v-container class="gray-wrapper" fluid>
    <div style="max-width:25rem;margin:0 auto;" class="config-title">
      <router-link to="/config" class="back-icon">
        <v-btn icon large>
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">
        {{ $t('recommend.myPerformance') }}
        
      </div>
    </div>

    <div class="panels-container">
      <div class="total-wrapper mb-3">
        <div class="font-weight-bold text-h6">
          Total: {{ totalCount }} {{ $t('recommend.people') }}
        </div>
      </div>
      <v-expansion-panels flat>
        <v-expansion-panel
          v-for="(phones, recommend) in recommend"
          :key="'expansion-' + recommend"
          class="shadow-10-20 mb-3"
        >
          <v-expansion-panel-header
            expand-icon="mdi-menu-down"
            class="font-weight-bold"
          >
            <div
              style="flex:none !important;display: flex;align-items: center;"
            >
              <div>{{ recommend }}</div>
              <div class="font-40 ml-1">
                ({{ phones.length }}{{ $t('recommend.people') }})
              </div>
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-card flat>
              <v-card-text
                style="overflow: auto;padding:0 1.3rem 1rem;"
              >
                <template v-if="phones.length === 0">
                  <div class="item-wrapper justify-center">
                    {{ $t('recommend.noReferrals') }}
                  </div>
                </template>
                <ul class="phone-list">
                  <li v-for="(phone, idx) in phones" :key="'phone-' + idx" class="phone-item">
                    <div class="item-wrapper">
                      <div class="date-wrapper">
                        <label>{{ $t('recommend.phone') }} : {{ phone }}</label>
                      </div>
                    </div>
                    <v-divider v-if="idx < phones.length - 1"></v-divider>
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      recommend : {},
      totalCount: 0
    }
  },
  methods: {
    btnShow(){
      //console.log( this.$store.state.user )
      return ( this.$store.state.user.is_admin > 0 || ( this.$store.state.user.is_bill > 0 && this.$store.state.user.grade > 1 ) ) ? true : false  ; 

    },
    btnColor( is_bill ) {
      return ( is_bill > 0 ) ? 'primary' : 'error'  ;
    } , 
     
  
  } , 
  computed: {
    // user() {
    //   return this.$store.getters.user
    // }
  },
  created() {
    this.$store.commit('loading', true)
    this.$store
      .dispatch('my_l_recommend')
      .then((res) => {
           console.log(res.data)
           if( res.data && res.data.total > 0  ) {
            this.recommend = res.data.result  ; 
            this.totalCount = res.data.total  ; 
           } else {
            this.recommend = {} ; 
            this.totalCount = 0  ; 
           }    
      })
      .catch((err) => {
        // console.log(err)
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('errorServer'),
          timeout: 2000
        })
      })
    this.$store.commit('loading', false)
  }
}
</script>

<style scoped>
.point-wrapper {
  position: absolute;
  right: 23px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
}
.item-wrapper {
  width: 100%;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.85rem;
  min-height: 3rem;
}
.date-wrapper {
  min-width: 6.5rem;
  margin-right: 0.5rem;
  color: #b1b1b1;
  font-weight: 500;
}
.mail-wrapper {
  /* display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end; */
  width: calc(100% - 7rem);
  text-align: end;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}
.mail-inner {
  width: 100%;
  text-align: end;
}
.phone-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.phone-item {
  width: 100%;
}
.total-wrapper {
  padding: 1rem;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 8px;
}
</style>
